module.exports = __webpack_public_path__ + "static/img/whatsapp.4a880068.png";